
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Layout from "components/Layout";
import Works from "components/works";
const getServerSideProps = async (context: any) => {
    const page = context.query.page || 1;
    const res = await fetch(`${process.env.NEXT_PUBLIC_BASE_API}/project?limit=9&offset=${(page - 1) * 9}`);
    const { data } = await res.json();
    if (!data) {
        console.log("error");
        return {
            notFound: true,
        };
    }
    return {
        props: { data: data }, // will be passed to the page component as props
    };
};
interface props {
    data: {
        res: IProject[];
        hasPrevious: boolean;
        hasNext: boolean;
    };
}
function works({ data }: props) {
    return (<Layout title="Works - Sonahang Rai" image="https://www.sonahangrai.com/wp-content/uploads/2021/08/1606228885780.jpg" description="All my works and projects examples which are done in frontend part. Some of them are slicing, some are wordpress frontend and some are react/nextjs.">
      <Works data={data.res} hasPrevious={data.hasPrevious} hasNext={data.hasNext}/>
    </Layout>);
}
export default works;

    async function __Next_Translate__getServerSideProps__198fecf4c71__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/works/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__198fecf4c71__ as getServerSideProps }
  